import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/thumbs-up.vue
var s = {
	name: "DtIconThumbsUp",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--thumbs-up"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Thumbs Up",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.553.776A.5.5 0 0 1 6.006.5a2.065 2.065 0 0 1 1.98 2.559L7.636 4.5h2.279a1.5 1.5 0 0 1 1.44 1.92l-1.165 4a1.5 1.5 0 0 1-1.44 1.08H2A1.5 1.5 0 0 1 .5 10V6A1.5 1.5 0 0 1 2 4.5h1.38a.5.5 0 0 0 .447-.277V4.22L5.554.776ZM3 5.5H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1v-5Zm1 5h4.75a.5.5 0 0 0 .48-.36l1.165-4a.5.5 0 0 0-.48-.64H7a.5.5 0 0 1-.486-.618l.5-2.06V2.82a1.065 1.065 0 0 0-.728-1.275L4.723 4.668A1.503 1.503 0 0 1 4 5.366V10.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=thumbs-up.js.map